// to remove, disable log on production and stg
const onRemoveLogs = () => {
  const protectedEnvironments = ['production', 'prod', 'prd', 'staging', 'stage', 'stg'];
  if (protectedEnvironments.includes(import.meta.env.MODE) || protectedEnvironments.includes(import.meta.env.NODE_ENV)) {
    console.log = () => { /* do nothing */ };
    console.error = () => { /* do nothing */ };
  }
};

const removeSurveyDataFromLocal = () => {
  sessionStorage.removeItem('refreshed');
  sessionStorage.removeItem('ansArr');
};

const errorMapping = {
"SESSION_ERROR_INV" : "/session-not-found",
"SESSION_ERROR_MSP" : "/bad-request",
"VERIFICATION_ERROR_CVF" : "/bad-request",
"VERIFICATION_ERROR_UNK": "/bad-request",
"VERIFICATION_ERROR_UNF": "/verification-error"
};

const getErrorRoute = (error) => {
  const statusCode = error?.response?.status;
  const customErrCode = error?.response?.data?.code;

  if (customErrCode && errorMapping[customErrCode]) return errorMapping[customErrCode];
  if (statusCode === 401) return '/unauthorized';
  if (statusCode === 403) return '/forbidden';
  if (statusCode >= 500) return '/server-error';
  return '/unknown-error';
};

export {
  onRemoveLogs,
  removeSurveyDataFromLocal,
  getErrorRoute
};
